var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FF4D63",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C11.654 0 15 3.346 15 7.5S11.654 15 7.5 15 0 11.625 0 7.5 3.346 0 7.5 0zm0 1.154c-3.52 0-6.346 2.827-6.346 6.346 0 3.52 2.827 6.346 6.346 6.346 3.52 0 6.346-2.856 6.346-6.346 0-3.52-2.827-6.346-6.346-6.346zm0 9.26c.366 0 .663.297.663.663 0 .366-.297.663-.663.663-.366 0-.663-.297-.663-.663 0-.366.297-.664.663-.664zm0-7.356c.317 0 .577.26.577.577V9.23c0 .285-.21.524-.484.57l-.093.007c-.317 0-.577-.26-.577-.577V3.635c0-.286.21-.525.484-.57l.093-.007z",
    transform: "translate(-756 -1579) translate(756 1579)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.828ca0b3ab9e6c438082d62bbe8caaa7.svg";
export { ForwardRef as ReactComponent };